import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  slot: "fixed",
  class: "full-width"
}
const _hoisted_2 = { class: "content" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ContentFixedNotification = _resolveComponent("ContentFixedNotification")!
  const _component_back_button = _resolveComponent("back-button")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_spinner = _resolveComponent("ion-spinner")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createBlock(_component_ion_content, {
    "force-overscroll": _ctx.forceOverscroll,
    class: _normalizeClass(["mb-0 px-0", { 'pa-0': _ctx.noPadding }])
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_ContentFixedNotification)
      ]),
      _createVNode(_component_ion_row, { class: "ion-justify-content-center background-color" }, {
        default: _withCtx(() => [
          (!_ctx.loading)
            ? (_openBlock(), _createBlock(_component_ion_col, {
                key: 0,
                size: "12",
                "size-sm": "12",
                "size-lg": "10",
                "size-xl": "8",
                class: _normalizeClass(["px-0", { 'pa-0': _ctx.noPadding }])
              }, {
                default: _withCtx(() => [
                  (_ctx.backBtn && !_ctx.isNative)
                    ? (_openBlock(), _createBlock(_component_back_button, {
                        key: 0,
                        backText: _ctx.backText,
                        class: "back-btn"
                      }, null, 8, ["backText"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", _hoisted_2, [
                    _renderSlot(_ctx.$slots, "default", {}, undefined, true)
                  ])
                ]),
                _: 3
              }, 8, ["class"]))
            : (_openBlock(), _createBlock(_component_ion_col, {
                key: 1,
                size: "1",
                class: "ion-text-center ion-align-items-center d-flex",
                style: {"height":"50vh"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_spinner, {
                    name: "lines-small",
                    class: "full-height full-width"
                  })
                ]),
                _: 1
              }))
        ]),
        _: 3
      }),
      _renderSlot(_ctx.$slots, "footer", {}, undefined, true)
    ]),
    _: 3
  }, 8, ["force-overscroll", "class"]))
}